import type { Store } from "@/types/content";

export const storesPart3: Store[] = [
  {
    id: "svc-9",
    slug: "taipei-hair-removal",
    name: "淨膚雷射除毛中心",
    description: "台北信義區專業除毛診所，提供雷射除毛、脈衝光（IPL）兩種永久性除毛服務。由護理師和醫美顧問組成的專業團隊，每位客人術前都進行完整的膚質評估，選擇最適合膚色與毛質的除毛方式。使用進口機型，操作精準且安全記錄良好。提供試打優惠方案，讓你在正式療程前先確認效果。",
    coverImage: "https://public.readdy.ai/ai/img_res/edited_3314ece222de821728344ffee2e2d28d_b5ba2bbb.jpg",
    category: "除毛",
    tags: ["除毛", "雷射除毛", "脈衝光", "信義區", "永久除毛"],
    priceRange: "$1,500 - $20,000 (課程)",
    location: "台北市信義區基隆路一段 176 號 8F",
    rating: 4.6,
    reviewCount: 267,
    features: ["膚質評估", "試打方案", "護理師執行", "低痛感設備", "療程追蹤"],
    content: [
      {
        _type: "richText",
        _key: "intro",
        content: "<p>淨膚雷射除毛中心位於台北信義區，是以安全和效果見長的除毛專門診所。這裡最值得信賴的是嚴格的術前評估流程——不只看膚色和毛質，還會詢問近期日曬狀況、藥物服用史，確保除毛當天的條件是安全的。</p>",
      },
      {
        _type: "featureList",
        _key: "features",
        title: "評比發現",
        features: [
          { _key: "f1", icon: "ri-user-search-line", title: "術前評估完整 ✓", description: "神秘客確認：評估流程約 20 分鐘，確認適合療程後才進行操作，不急著推課程" },
          { _key: "f2", icon: "ri-heart-pulse-line", title: "操作過程穩定 ✓", description: "操作護理師手法穩定，有詳細說明每個步驟，降低緊張感" },
          { _key: "f3", icon: "ri-file-list-3-line", title: "療程記錄透明 ✓", description: "每次治療後提供治療記錄表，包含使用機型、能量設定，便於追蹤" },
        ],
      },
      {
        _type: "faq",
        _key: "faq",
        title: "雷射除毛常見問題",
        items: [
          { _key: "q1", question: "雷射除毛需要幾次才能永久？", answer: "一般需要 6-8 次療程，每次間隔 4-8 週（配合毛髮生長週期）。達到永久除毛效果後，部分人可能每年需要 1-2 次維護療程。" },
          { _key: "q2", question: "除毛前後有什麼禁忌？", answer: "術前 4 週避免日曬（影響效果與安全性）；術後 1 週避免日曬、三溫暖、激烈運動；術後每天做好防曬。" },
        ],
      },
      {
        _type: "cta",
        _key: "cta",
        title: "查看完整除毛評比",
        subtitle: "神秘客公正評比台北除毛診所，帶你找到安全有效的選擇",
        buttonLabel: "查看店家詳情",
        buttonHref: "#",
      },
    ],
    seo: {
      title: "淨膚雷射除毛中心｜台北信義區除毛評比",
      description: "台北信義區雷射除毛評比！完整術前評估，試打方案可嘗試。4.6 星 267 則評價。",
      keywords: ["台北除毛", "雷射除毛", "脈衝光除毛", "永久除毛"],
    },
  },
  {
    id: "svc-10",
    slug: "taipei-portrait-studio",
    name: "形象光影攝影工作室",
    description: "台北信義區的個人形象攝影工作室，專精職業形象照與個人品牌攝影。攝影師具有商業廣告攝影背景，善於引導不擅長拍照的客人自然展現自信。工作室配備專業燈光設備與多種背景選項，提供妝髮師合作方案。完整交付時間為拍攝後 2 週，附完整選片服務。",
    coverImage: "https://public.readdy.ai/ai/img_res/edited_c5895bf058557193fab20fda5540d59e_e17cbddd.jpg",
    category: "攝影",
    tags: ["攝影", "形象照", "個人品牌", "職業照", "信義區"],
    priceRange: "$5,000 - $18,000",
    location: "台北市信義區松智路 12 號 9F",
    rating: 4.8,
    reviewCount: 187,
    features: ["商業攝影背景", "妝髮師合作", "2週交付", "完整選片", "多種背景"],
    content: [
      {
        _type: "richText",
        _key: "intro",
        content: "<p>形象光影攝影工作室的攝影師背景是商業廣告攝影，這讓他的個人形象照作品有別於一般寫真攝影——更注重光線控制與細節表達，照片質感更接近品牌大片的標準。</p><p>神秘客測試時，攝影師花了大量時間在拍攝前進行溝通——了解你的職業、希望傳遞的個人品牌形象、以及拍完照片的使用場合，這些都影響最終的造型方向和拍攝風格。</p>",
      },
      {
        _type: "featureList",
        _key: "features",
        title: "評比發現",
        features: [
          { _key: "f1", icon: "ri-camera-line", title: "引導能力強 ✓", description: "不擅長拍照的神秘客測試：攝影師持續給出具體姿態引導，不讓客人自己不知所措" },
          { _key: "f2", icon: "ri-image-2-line", title: "後製質感高 ✓", description: "精修照片保留真實感，無過度磨皮，光線處理自然，很適合用於職業場合" },
          { _key: "f3", icon: "ri-time-line", title: "準時交付 ✓", description: "神秘客確認：2 週內準時收到精選修圖，並附有電子檔案使用授權說明" },
        ],
      },
      {
        _type: "cta",
        _key: "cta",
        title: "查看完整形象攝影評比",
        subtitle: "神秘客公正評比台北個人形象攝影師，帶你找到最適合的風格",
        buttonLabel: "查看店家詳情",
        buttonHref: "#",
      },
    ],
    seo: {
      title: "形象光影攝影工作室｜台北信義區形象照評比",
      description: "台北信義區個人形象攝影評比！商業攝影背景，引導能力強，2週交付。4.8 星 187 則評價。",
      keywords: ["台北形象攝影", "職業照", "個人品牌攝影", "形象照推薦"],
    },
  },
  {
    id: "svc-11",
    slug: "taipei-scalp-clinic",
    name: "源生頭皮護理診所",
    description: "台北中山區的專業頭皮護理工作室，以頭皮微鏡檢測為基礎，提供針對性的掉髮、出油、敏感頭皮療程。由具有皮膚科諮詢資歷的頭皮顧問主持，確保療程建議有科學依據。使用日本進口的頭皮護理產品線，溫和有效。不使用任何含刺激性化學成分的產品。",
    coverImage: "https://public.readdy.ai/ai/img_res/edited_39b10cca2111096ba2b5a11d5fdb8136_62ec1532.jpg",
    category: "頭皮護理",
    tags: ["頭皮護理", "掉髮", "頭皮分析", "中山區", "日本護理產品"],
    priceRange: "$1,800 - $6,000",
    location: "台北市中山區南京東路三段 88 號 7F",
    rating: 4.7,
    reviewCount: 213,
    features: ["頭皮微鏡檢測", "掉髮分析", "日本護理產品", "無刺激配方", "療程追蹤"],
    content: [
      {
        _type: "richText",
        _key: "intro",
        content: "<p>源生頭皮護理診所最大的特色是「先診斷再治療」——每次療程前用頭皮顯微鏡拍攝頭皮狀況（毛孔、毛囊密度、頭皮油脂分布），留下記錄後再設計療程。這讓療程的針對性大幅提高，也讓你能客觀看到自己頭皮狀況的變化。</p>",
      },
      {
        _type: "featureList",
        _key: "features",
        title: "評比發現",
        features: [
          { _key: "f1", icon: "ri-microscope-line", title: "頭皮檢測具體 ✓", description: "神秘客確認：顯微鏡拍攝後師傅詳細說明每個問題區域，不是模糊帶過" },
          { _key: "f2", icon: "ri-leaf-line", title: "產品成分安全 ✓", description: "主動提供產品成分說明，無添加 SLS、矽靈、合成香精" },
          { _key: "f3", icon: "ri-bar-chart-line", title: "療效可追蹤 ✓", description: "每次療程保留顯微照片記錄，讓療效進展可以客觀比較" },
        ],
      },
      {
        _type: "cta",
        _key: "cta",
        title: "查看完整頭皮護理評比",
        subtitle: "神秘客公正評比台北頭皮護理工作室，帶你找到最有效的頭皮解方",
        buttonLabel: "查看店家詳情",
        buttonHref: "#",
      },
    ],
    seo: {
      title: "源生頭皮護理診所｜台北中山區頭皮護理評比",
      description: "台北中山區頭皮護理評比！頭皮微鏡檢測，掉髮分析精準，日本護理產品。4.7 星 213 則評價。",
      keywords: ["台北頭皮護理", "掉髮治療", "頭皮分析", "頭皮護理推薦"],
    },
  },
  {
    id: "svc-12",
    slug: "taipei-yoga-studio",
    name: "靜心瑜珈皮拉提斯",
    description: "位於信義區的綜合運動空間，將傳統瑜珈的身心平衡與現代皮拉提斯的肌力訓練完美結合。採用 8 人小班制教學，每位學員都能獲得老師充分的關注與指導。空間設計明亮通透，搭配芬多精環繞的綠植裝飾，讓運動不再只是苦練，而是一場身心靈的療癒之旅。提供空中瑜珈課程，是信義區最具特色的瑜珈工作室之一。",
    coverImage: "https://public.readdy.ai/ai/img_res/edited_53775dace1e6e73e72586b60193526fa_a802dbec.jpg",
    category: "瑜珈",
    tags: ["瑜珈", "皮拉提斯", "空中瑜珈", "小班制", "信義區"],
    priceRange: "$800 - $2,000 /堂",
    location: "台北市信義區松壽路 36 號 5F",
    rating: 4.7,
    reviewCount: 289,
    features: ["8人小班", "空中瑜珈", "皮拉提斯", "免費體驗課", "淋浴間"],
    content: [
      {
        _type: "richText",
        _key: "intro",
        content: "<p>靜心瑜珈皮拉提斯位於信義區，是一間結合傳統瑜珈與現代皮拉提斯的綜合運動空間。最大特色是<strong>嚴格的 8 人小班制教學</strong>，老師能夠仔細觀察每位學員的動作並給予調整。</p>",
      },
      {
        _type: "featureList",
        _key: "features",
        title: "評比發現",
        features: [
          { _key: "f1", icon: "ri-group-line", title: "班級人數嚴格控制 ✓", description: "神秘客確認：班級確實維持 8 人以內，老師每堂課都能關注到每個學員" },
          { _key: "f2", icon: "ri-hand-coin-line", title: "老師調整積極 ✓", description: "課程中老師主動走近調整動作，不只是站在前面示範" },
          { _key: "f3", icon: "ri-leaf-line", title: "空間舒適宜人 ✓", description: "大量綠植讓空間氣氛很放鬆，搭配自然採光，整個練習體驗很舒服" },
        ],
      },
      {
        _type: "cta",
        _key: "cta",
        title: "查看完整瑜珈評比",
        subtitle: "神秘客公正評比台北瑜珈工作室，帶你找到最值得的課程",
        buttonLabel: "查看店家詳情",
        buttonHref: "#",
      },
    ],
    seo: {
      title: "靜心瑜珈皮拉提斯｜信義區小班制瑜珈評比",
      description: "信義區小班制瑜珈皮拉提斯評比！空中瑜珈特色課程，老師調整積極。4.7 星 289 則評價。",
      keywords: ["台北瑜珈", "信義區瑜珈", "皮拉提斯", "空中瑜珈", "小班瑜珈"],
    },
  },
  {
    id: "svc-13",
    slug: "taipei-makeup-studio",
    name: "GLOW 彩妝造型工作室",
    description: "位於台北中山區的專業彩妝造型工作室，以韓系清透妝感和新娘妝聞名。彩妝師平均資歷超過 5 年，使用專櫃級彩妝品牌，敏感肌也能安心。提供新娘妝、日常妝、整體造型等多元服務，每位客人都享有充分的妝前溝通時間，確保妝容風格符合個人期待。",
    coverImage: "https://public.readdy.ai/ai/img_res/edited_829c3a2f69b58afa1b57525186239c7f_a33e585c.jpg",
    category: "彩妝造型",
    tags: ["彩妝造型", "新娘妝", "韓系妝容", "整體造型", "中山區"],
    priceRange: "$1,500 - $8,000",
    location: "台北市中山區中山北路二段 88 號 4F",
    rating: 4.8,
    reviewCount: 198,
    features: ["專櫃級產品", "韓系清透妝感", "妝前溝通充分", "新娘試妝", "敏感肌適用"],
    content: [
      {
        _type: "richText",
        _key: "intro",
        content: "<p>GLOW 彩妝造型工作室是台北中山區最受好評的彩妝工作室之一。與其他店家的最大不同是——每次服務前都會進行 15-20 分鐘的妝前溝通，了解你的場合需求、服裝風格、以及個人對妝容的偏好，確保最後的成果真的適合你。</p>",
      },
      {
        _type: "featureList",
        _key: "features",
        title: "評比發現",
        features: [
          { _key: "f1", icon: "ri-paint-brush-line", title: "技術細膩 ✓", description: "底妝清透不厚重，眼妝層次分明，不會出現『面具感』" },
          { _key: "f2", icon: "ri-shield-check-line", title: "產品品質有保障 ✓", description: "使用專櫃級彩妝品牌，色號齊全，敏感肌也能安心" },
          { _key: "f3", icon: "ri-chat-1-line", title: "溝通充分 ✓", description: "妝前溝通時間長達 15-20 分鐘，會參考你帶來的服裝照片和參考圖" },
        ],
      },
      {
        _type: "faq",
        _key: "faq",
        title: "彩妝造型常見問題",
        items: [
          { _key: "q1", question: "新娘妝需要提前多久預約？", answer: "建議至少提前 3-6 個月預約，熱門檔期（如五月、十月）甚至需要提前一年。預約時通常包含一次試妝。" },
          { _key: "q2", question: "妝容可以維持多久？", answer: "新娘妝通常可維持 8-12 小時，日常妝約 6-8 小時。工作室會提供補妝小物（吸油面紙、小罐蜜粉）讓你帶著備用。" },
        ],
      },
      {
        _type: "cta",
        _key: "cta",
        title: "查看完整彩妝造型評比",
        subtitle: "神秘客公正評比台北彩妝造型工作室，帶你找到最適合的彩妝師",
        buttonLabel: "查看店家詳情",
        buttonHref: "#",
      },
    ],
    seo: {
      title: "GLOW 彩妝造型工作室｜台北中山區彩妝評比",
      description: "台北中山區彩妝造型評比！韓系清透妝感，專櫃級產品，新娘妝試妝服務。4.8 星 198 則評價。",
      keywords: ["台北彩妝造型", "新娘妝", "韓系妝容", "彩妝推薦"],
    },
  },
  {
    id: "svc-14",
    slug: "taipei-warm-cupping",
    name: "東方暖罐養生館",
    description: "位於台北中山區的傳統暖罐養生會館，由具中醫經絡背景的師傅主持。暖罐療法結合傳統拔罐與現代熱療，透過加熱後的特製罐具吸附在經絡穴位上，達到促進氣血循環、舒緩深層肌肉緊繃的效果。所有罐具皆為一次性或經過高溫消毒，衛生標準嚴格。療程後提供體質分析與日常保養建議。",
    coverImage: "https://public.readdy.ai/ai/img_res/edited_224dc3391181fe470394bc24ebc39441_9adac7bc.jpg",
    category: "暖罐",
    tags: ["暖罐", "拔罐", "經絡調理", "中醫養生", "中山區"],
    priceRange: "$800 - $2,000",
    location: "台北市中山區林森北路 150 號 2F",
    rating: 4.7,
    reviewCount: 156,
    features: ["中醫經絡背景", "一次性罐具", "體質分析", "經絡調理", "療程追蹤"],
    content: [
      {
        _type: "richText",
        _key: "intro",
        content: "<p>東方暖罐養生館最大的特色是師傅的中醫經絡背景——每位師傅都接受過中醫經絡學培訓，不只是「吸罐子」，而是根據你的體質和痠痛部位，選擇最適合的經絡穴位進行暖罐療法。</p>",
      },
      {
        _type: "featureList",
        _key: "features",
        title: "評比發現",
        features: [
          { _key: "f1", icon: "ri-user-star-line", title: "師傅具中醫背景 ✓", description: "師傅接受過中醫經絡學培訓，能針對體質選擇最適合的穴位，不是隨意吸附" },
          { _key: "f2", icon: "ri-shield-check-line", title: "衛生標準嚴格 ✓", description: "所有罐具皆為一次性使用或經過高溫消毒，杜絕交叉感染風險" },
          { _key: "f3", icon: "ri-file-list-3-line", title: "療程後建議具體 ✓", description: "每次療程後提供體質分析與日常保養建議，不只是做完就結束" },
        ],
      },
      {
        _type: "cta",
        _key: "cta",
        title: "查看完整暖罐評比",
        subtitle: "神秘客公正評比台北暖罐養生館，帶你找到手法正宗的傳統熱療",
        buttonLabel: "查看店家詳情",
        buttonHref: "#",
      },
    ],
    seo: {
      title: "東方暖罐養生館｜台北中山區暖罐評比",
      description: "台北中山區暖罐評比！中醫經絡背景師傅，一次性罐具衛生標準高。4.7 星 156 則評價。",
      keywords: ["台北暖罐", "暖罐推薦", "拔罐", "經絡調理", "中醫養生"],
    },
  },
  {
    id: "svc-15",
    slug: "taipei-color-lab",
    name: "色彩研究所 Color Lab",
    description: "位於台北中山區的專業色彩鑑定工作室，以四季型色彩分析與個人色調定位為核心服務。顧問團隊擁有日本個人色彩協會認證，draping 測試使用多達 60 塊專業布料，確保分析結果精準。提供完整電子版報告書與隨身色卡，讓你能輕鬆應用在日常穿搭與彩妝選色上。",
    coverImage: "https://public.readdy.ai/ai/img_res/edited_b2a0e298266fc34954249e24d686d439_9577bc30.jpg",
    category: "色彩鑑定",
    tags: ["色彩鑑定", "個人色彩", "四季型分析", "draping測試", "中山區"],
    priceRange: "$2,500 - $6,000",
    location: "台北市中山區南京東路二段 120 號 5F",
    rating: 4.8,
    reviewCount: 134,
    features: ["日本認證顧問", "60塊draping布", "電子版報告書", "隨身色卡", "穿搭應用指導"],
    content: [
      {
        _type: "richText",
        _key: "intro",
        content: "<p>色彩研究所 Color Lab 是台北少數擁有日本個人色彩協會認證顧問的色彩鑑定工作室。與一般「憑感覺」判斷色彩屬性的店家不同，這裡的 draping 測試使用多達 60 塊專業布料，每個步驟都有系統化的判定標準。</p><p>神秘客體驗後印象最深的是報告書的完整性——除了四季型判定，還包含最佳色盤表、彩妝色號建議、以及 10 套穿搭應用示範，拿到就能直接用。</p>",
      },
      {
        _type: "featureList",
        _key: "features",
        title: "評比發現",
        features: [
          { _key: "f1", icon: "ri-palette-line", title: "draping 測試精準 ✓", description: "60 塊布料逐塊比對，過程約 40 分鐘，判定標準嚴謹不馬虎" },
          { _key: "f2", icon: "ri-file-text-line", title: "報告書完整實用 ✓", description: "電子版報告書 + 隨身色卡，逛街買衣服時可以直接參考" },
          { _key: "f3", icon: "ri-shirt-line", title: "穿搭應用指導到位 ✓", description: "顧問會根據你現有衣櫥給具體建議，不是只給理論" },
        ],
      },
      {
        _type: "faq",
        _key: "faq",
        title: "色彩鑑定常見問題",
        items: [
          { _key: "q1", question: "色彩鑑定後多久需要重新測試？", answer: "膚色和眼色不會改變，所以理論上一次鑑定終身受用。但如果你做了大改變（如漂髮、長期日曬膚色變深），可以考慮重新評估。" },
          { _key: "q2", question: "可以帶朋友一起來嗎？", answer: "可以，工作室提供雙人色彩鑑定方案，兩人同時進行還能互相觀察對比效果，非常有趣。" },
        ],
      },
      {
        _type: "cta",
        _key: "cta",
        title: "查看完整色彩鑑定評比",
        subtitle: "神秘客公正評比台北色彩鑑定工作室，帶你找到最精準的色調定位",
        buttonLabel: "查看店家詳情",
        buttonHref: "#",
      },
    ],
    seo: {
      title: "色彩研究所 Color Lab｜台北中山區色彩鑑定評比",
      description: "台北中山區色彩鑑定評比！日本認證顧問，60 塊 draping 布料測試，電子版報告書。4.8 星 134 則評價。",
      keywords: ["台北色彩鑑定", "個人色彩分析", "四季型配色", "色彩鑑定推薦"],
    },
  },
  {
    id: "svc-16",
    slug: "taipei-fashion-stylist",
    name: "風格衣櫥 STYLIST",
    description: "位於台北大安區的個人穿搭造型工作室，專精風格定位、膠囊衣櫥規劃與採購陪同服務。造型師具有時尚雜誌編輯與明星造型背景，能精準判斷每個人的風格潛力。提供風格定位諮詢、衣櫥整理斷捨離、以及實體採購陪同三種核心服務。每個方案都附贈數位穿搭相簿，讓你每天打開衣櫥就知道穿什麼。",
    coverImage: "https://public.readdy.ai/ai/img_res/edited_4dc11b1570f50c9555e26514b1b8e088_8716e13e.jpg",
    category: "穿搭",
    tags: ["穿搭", "風格定位", "膠囊衣櫥", "採購陪同", "大安區"],
    priceRange: "$3,000 - $12,000",
    location: "台北市大安區忠孝東路四段 300 號 4F",
    rating: 4.7,
    reviewCount: 112,
    features: ["風格定位", "衣櫥整理", "採購陪同", "數位穿搭相簿", "明星造型背景"],
    content: [
      {
        _type: "richText",
        _key: "intro",
        content: "<p>風格衣櫥 STYLIST 的創辦人背景是時尚雜誌編輯與明星造型師，這讓工作室的風格定位服務有別於一般的穿搭顧問——不只是幫你挑衣服，而是幫你找到屬於自己的「風格語言」。</p><p>神秘客體驗了完整方案（風格定位 + 衣櫥整理 + 採購陪同），整個過程約 8 小時分兩天完成。最驚豔的是數位穿搭相簿——造型師把你的衣服搭配成 30 套不同風格，每天不知道穿什麼就翻相簿。</p>",
      },
      {
        _type: "featureList",
        _key: "features",
        title: "評比發現",
        features: [
          { _key: "f1", icon: "ri-user-search-line", title: "風格定位深入 ✓", description: "諮詢時間長達 90 分鐘，從生活習慣到職場需求都會了解，不只憑感覺判定" },
          { _key: "f2", icon: "ri-image-line", title: "數位穿搭相簿超實用 ✓", description: "30 套搭配方案 + 購物清單，每天省 20 分鐘思考穿什麼" },
          { _key: "f3", icon: "ri-store-line", title: "採購陪同專業 ✓", description: "不強推品牌，根據預算找到最適合的單品，現場教你判斷版型和材質" },
        ],
      },
      {
        _type: "faq",
        _key: "faq",
        title: "穿搭造型常見問題",
        items: [
          { _key: "q1", question: "衣櫥整理會強迫丟掉很多衣服嗎？", answer: "不會。好的造型師會幫你分類：保留、改造、淘汰。很多你以為不適合的衣服，可能只是搭配方式不對，造型師會教你新穿法。" },
          { _key: "q2", question: "採購陪同有指定商場或品牌嗎？", answer: "可以自選商場，造型師會根據你的預算和風格規劃採購路線。預算友善的選擇包括 UNIQLO、ZARA，高預算則可前往百貨專櫃。" },
        ],
      },
      {
        _type: "cta",
        _key: "cta",
        title: "查看完整穿搭造型評比",
        subtitle: "神秘客公正評比台北穿搭造型工作室，帶你找到最適合的風格導師",
        buttonLabel: "查看店家詳情",
        buttonHref: "#",
      },
    ],
    seo: {
      title: "風格衣櫥 STYLIST｜台北大安區穿搭造型評比",
      description: "台北大安區穿搭造型評比！風格定位深入，數位穿搭相簿實用，採購陪同專業。4.7 星 112 則評價。",
      keywords: ["台北穿搭", "穿搭顧問", "風格定位", "膠囊衣櫥", "造型師推薦"],
    },
  },
  {
    id: "svc-17",
    slug: "taipei-image-consulting",
    name: "蛻變形象顧問所",
    description: "位於台北信義區的頂級形象管理顧問所，提供從色彩分析、穿搭指導、姿態調整到表達方式的全方位形象改造服務。顧問團隊具有企業培訓與品牌顧問背景，專精職場形象與個人品牌塑造。完整方案包含 3 個月跟進服務，確保形象改變能持續落實到日常生活中。",
    coverImage: "https://public.readdy.ai/ai/img_res/edited_741ad649e0073e89e293b73c4a121c07_97b8e36a.jpg",
    category: "形象管理",
    tags: ["形象管理", "形象顧問", "職場形象", "個人品牌", "信義區"],
    priceRange: "$8,000 - $25,000",
    location: "台北市信義區松高路 18 號 8F",
    rating: 4.9,
    reviewCount: 156,
    features: ["全方位改造", "企業培訓背景", "3個月跟進", "職場形象", "個人品牌"],
    content: [
      {
        _type: "richText",
        _key: "intro",
        content: "<p>蛻變形象顧問所是台北信義區最高規格的形象管理服務提供者。與一般穿搭顧問最大的不同是——這裡的服務涵蓋「形象」的全部面向：色彩分析、穿搭指導、姿態調整、表達方式、甚至到 LinkedIn 頭像與個人網站的形象規劃。</p><p>神秘客體驗了完整方案，整個過程分為四個階段：評估訪談（2 小時）→ 色彩與風格分析（3 小時）→ 衣櫥重建與採購（1 天）→ 姿態與表達訓練（2 小時）。最讓人安心的是 3 個月跟進服務，顧問會定期確認你的改變狀況並給予調整建議。</p>",
      },
      {
        _type: "featureList",
        _key: "features",
        title: "評比發現",
        features: [
          { _key: "f1", icon: "ri-palette-line", title: "色彩分析精準 ✓", description: "結合四季型與個人風格雙系統分析，結果比一般色彩鑑定更深入" },
          { _key: "f2", icon: "ri-user-voice-line", title: "姿態與表達訓練實用 ✓", description: "不只是站好看，而是教你如何在會議、簡報、社交場合中展現自信氣場" },
          { _key: "f3", icon: "ri-time-line", title: "3 個月跟進服務到位 ✓", description: "每兩週一次線上回訪，確保改變不只是短期衝動，而是真正融入生活" },
        ],
      },
      {
        _type: "faq",
        _key: "faq",
        title: "形象管理常見問題",
        items: [
          { _key: "q1", question: "形象管理服務需要多久時間？", answer: "完整方案約分 2-3 次完成，總計約 8-10 小時。如果時間有限，也可以選擇單項服務（如只有色彩分析或只有穿搭指導），每次約 2-3 小時。" },
          { _key: "q2", question: "形象管理後我會變成完全不同的人嗎？", answer: "不會。好的形象管理是「強化你本來就有的特質」，而不是把你變成別人。顧問會根據你的個性、職業、生活方式，找到最適合你的形象表達方式。" },
        ],
      },
      {
        _type: "cta",
        _key: "cta",
        title: "查看完整形象管理評比",
        subtitle: "神秘客公正評比台北形象管理顧問，帶你找到最全方位的改造服務",
        buttonLabel: "查看店家詳情",
        buttonHref: "#",
      },
    ],
    seo: {
      title: "蛻變形象顧問所｜台北信義區形象管理評比",
      description: "台北信義區形象管理評比！全方位改造服務，企業培訓背景顧問，3 個月跟進。4.9 星 156 則評價。",
      keywords: ["台北形象管理", "形象顧問", "職場形象", "個人品牌", "形象改造"],
    },
  },
  {
    id: "svc-18",
    slug: "taipei-singing-bowl-healing",
    name: "頌缽靜心療癒空間",
    description: "位於台北中山區的頌缽療癒工作室，以尼泊爾手工頌缽與專業冥想引導為核心服務。引導師受過尼泊爾頌缽協會認證，擅長以聲波共振幫助客人釋放深層壓力。空間採用全隔音設計，搭配柔和燈光與草本香氛，營造完全隔絕都市喧嚣的靜謐氛圍。提供個人頌缽療癒、團體聲音浴、以及冥想引導課程。",
    coverImage: "https://readdy.ai/api/search-image?query=Serene%20singing%20bowl%20healing%20room%20with%20nepalese%20bowls%20candles%20soft%20warm%20lighting%20meditation%20cushions%20peaceful%20zen%20atmosphere%20clean%20simple%20background%20photography%20wellness%20studio&width=1200&height=630&seq=418&orientation=landscape",
    category: "光療舒壓",
    tags: ["頌缽", "冥想", "聲音療癒", "光療舒壓", "中山區"],
    priceRange: "$1,200 - $3,500",
    location: "台北市中山區南京東路二段 88 號 3F",
    rating: 4.8,
    reviewCount: 142,
    features: ["尼泊爾頌缽認證", "全隔音空間", "冥想引導", "聲音浴", "草本茶靜心"],
    content: [
      {
        _type: "richText",
        _key: "intro",
        content: "<p>頌缽靜心療癒空間位於台北中山區，是一間以尼泊爾頌缽為核心工具的光療舒壓工作室。最大的特色是引導師的專業認證——每位引導師都接受過尼泊爾頌缽協會的培訓，不只是「敲缽」，而是懂得如何用聲波的頻率與振動，針對不同身心狀態設計療程。</p><p>神秘客體驗了個人頌缽療癒（90 分鐘），整個過程從呼吸調整開始，逐步進入頌缽聲波的環繞中。引導師會根據你的身心狀態選擇不同大小的缽，大缽的低頻共振能深入臟器層面，小缽的高頻則能清理思緒雜訊。</p>",
      },
      {
        _type: "featureList",
        _key: "features",
        title: "評比發現",
        features: [
          { _key: "f1", icon: "ri-award-line", title: "引導師認證專業 ✓", description: "尼泊爾頌缽協會認證，不只是敲缽，而是針對身心狀態設計聲波療程" },
          { _key: "f2", icon: "ri-volume-mute-line", title: "隔音效果極佳 ✓", description: "全隔音空間設計，即使位於中山區鬧區，室內也聽不到任何車聲" },
          { _key: "f3", icon: "ri-cup-line", title: "療程後靜心時間 ✓", description: "不會療程結束就趕人，提供草本茶與 15 分鐘靜心時間，讓效果沉澱" },
        ],
      },
      {
        _type: "faq",
        _key: "faq",
        title: "光療舒壓常見問題",
        items: [
          { _key: "q1", question: "頌缽療癒會有宗教色彩嗎？", answer: "這間工作室將頌缽定位為「聲音療癒工具」，引導過程無宗教儀式或信仰要求，適合所有背景的人。" },
          { _key: "q2", question: "初次體驗建議選什麼療程？", answer: "建議從「個人頌缽療癒」開始（90 分鐘，$2,500），讓引導師了解你的狀態後再推薦後續課程。如果預算有限，也可以選擇團體聲音浴（60 分鐘，$1,200）。" },
        ],
      },
      {
        _type: "cta",
        _key: "cta",
        title: "查看完整光療舒壓評比",
        subtitle: "神秘客公正評比台北光療舒壓工作室，帶你找到最能卸下壓力的好去處",
        buttonLabel: "查看店家詳情",
        buttonHref: "#",
      },
    ],
    seo: {
      title: "頌缽靜心療癒空間｜台北中山區頌缽冥想評比",
      description: "台北中山區頌缽療癒評比！尼泊爾認證引導師，全隔音空間，療程後靜心時間。4.8 星 142 則評價。",
      keywords: ["台北頌缽", "頌缽療癒", "冥想推薦", "聲音療癒", "光療舒壓"],
    },
  },
];